import { useFormikContext } from "formik";
import { sftpParserTypeEnum } from "kubb";
import type React from "react";
import { ButtonGroupField } from "../../../components/Forms/ButtonGroup";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";
import { SelectComboField } from "../../../components/Forms/SelectCombo/SelectCombo";

// Sentinel value for "None" option - converted to null on form submission
export const NONE_PARSER_TYPE = "__none__";

interface SftpReceiverIntegrationFormProps {
  namespace: string;
}

export default function SftpReceiverIntegrationForm(
  props: SftpReceiverIntegrationFormProps,
): React.ReactElement {
  const { values } = useFormikContext<Record<string, unknown>>();
  const withNamespace = (field: string) => {
    return `${props.namespace}.${field}`;
  };

  // Get the current auth type from form values
  const integration = values[props.namespace] as
    | { sftpCredentials?: { type?: string } }
    | undefined;
  const authType = integration?.sftpCredentials?.type || "public_key";
  const isBasicAuth = authType === "basic_auth";

  return (
    <>
      <SelectComboField
        fieldName={withNamespace("parser_type")}
        label={{ label: "Parser Type" }}
        options={[
          { value: NONE_PARSER_TYPE, label: "None" },
          { value: sftpParserTypeEnum.kamstrup_ready, label: "Kamstrup Ready" },
          {
            value: sftpParserTypeEnum.bring_energy_bms,
            label: "Bring Energy BMS",
          },
        ]}
      />
      <ButtonGroupField
        fieldName={withNamespace("sftpCredentials.type")}
        label={{ label: "Authentication Type" }}
        options={[
          { value: "public_key", label: "SSH Key" },
          { value: "basic_auth", label: "Password" },
        ]}
      />
      {isBasicAuth ? (
        <NewTextFormComponent
          fieldName={withNamespace("sftpCredentials.password")}
          label={{ label: "Password" }}
          type={"password"}
        />
      ) : (
        <NewTextFormComponent
          fieldName={withNamespace("sftpCredentials.publicKey")}
          label={{ label: "Your Public SSH Key" }}
          type={"textarea"}
        />
      )}
    </>
  );
}
